<template lang="pug">
  section(:class="{'section--light': light, 'section--dark': dark }").text-center(v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }")
    .container
      .row
        .col-lg-3.col-md-6
          .h1--lg
            number(:from="0" :to="number1" ref="number1" :animationPaused="true")
            span {{ postNumber1 }}
          p {{ sentence1 }}
        .col-lg-3.col-md-6
          .h1--lg
            number(:from="0" :to="number2" ref="number2" :animationPaused="true")
            span {{ postNumber2 }}
          p {{ sentence2 }}
        .col-lg-3.col-md-6
          .h1--lg
            number(:from="0" :to="number3" ref="number3" :animationPaused="true")
            span {{ postNumber3 }}
          p  {{ sentence3 }}
        .col-lg-3.col-md-6
          .h1--lg
            number(:from="0" :to="number4" ref="number4" :animationPaused="true")
            span {{ postNumber4 }}
          p  {{ sentence4 }}

</template>

<script>
  export default {
    data: () => ({
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        thresholds: [0]
      } // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    }),
    props: {
      light: {
        type: Boolean,
        default: true
      },
      dark: {
        type: Boolean,
        default: false
      },
      number1: Number,
      number2: {
        type: Number,
        default: 206
      },
      number3: {
        type: Number,
        default: 98
      },
      number4: Number,
      postNumber1: {
        type: String,
        default: ''
      },
      postNumber2: {
        type: String,
        default: ''
      },
      postNumber3: {
        type: String,
        default: '%'
      },
      postNumber4: {
        type: String,
        default: ''
      },
      sentence1: {
        type: String,
        default: 'patients nous font confiance, jour après jour'
      },
      sentence2: {
        type: String,
        default: 'os dans votre organisme attendent un ostéopathe'
      },
      sentence3: {
        type: String,
        default: 'des patients recommandent notre service à leur entourage'
      },
      sentence4: {
        type: String,
        default: 'ostéopathes prêts à vous tendre la main aujourd\'hui'
      }
    },
    methods: {
      onWaypoint ({ going, direction }) {
        // going: in, out
        // direction: top, right, bottom, left
        if (going === this.$waypointMap.GOING_IN) {
          this.$refs.number1.play()
          this.$refs.number2.play()
          this.$refs.number3.play()
          this.$refs.number4.play()
        }
      }
    }
  }
</script>
